import { useState, useEffect } from 'react'
import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico'
import type { Category } from '../types'

interface CategoriesResponse {
  categories: Category[]
}

/**
 * Fetches project categories from GET /api/arc_mosaico/categories.
 * Returns empty array when no categories exist yet.
 */
export function useCategories() {
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    async function load() {
      try {
        const response = await api.get<CategoriesResponse>(ARC_MOSAICO_ENDPOINTS.categories.list)
        if (!cancelled) {
          setCategories(Array.isArray(response.data?.categories) ? response.data.categories : [])
        }
      } catch {
        // Categories are optional — fail silently
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    load()
    return () => { cancelled = true }
  }, [])

  return { categories, loading }
}
